import { Component, OnInit } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {

  token;
  constructor(private http: HttpClient,private router: Router) { }
  username;
  pass;
  aud: Boolean = false;

  saveToken(){
    localStorage.setItem('token', this.token);
  }
  show: boolean= false;
  
  ngOnInit(): void {
    if (window.screen.width <= 500) { // 768px portrait
      this.show = true;
    }
    else{
      this.show = false;
    } 


    this.http.get<any>("https://api2.ecell.in/vsm/mazak/").subscribe(
      data=>{
        console.log(data)
        if (data == 'done'){
          this.aud = true
        }
        else{
          this.aud = false
        }
      }
    )

  }

  submit(){
    console.log(this.username, this.pass)
    var body = new FormData();
    body.append('username', this.username);
    // body.append('fname', this.fname);
    // body.append('lname', this.lname);
    body.append('password', this.pass)
    // body.append('confirm', this.confirm)
    // body.append('email',this.email)
    
    this.http.post<any>("https://api2.ecell.in/api-token-auth/", body).subscribe(
      data=>{
        console.log(data)
        localStorage.setItem('token', data.token)
        this.router.navigate(['/dashboard'], { queryParams: { type: 't' } })
      },
      error=>{
        console.log(error)
        alert('Username already in user')
      }
    )
  }

}
